import * as Config from '../config';
import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { TouchBackend } from 'react-dnd-touch-backend';

import './library/custom/-APP_TARGET/core.css';
import './Library.css'; /* Global App */
import './library/custom/-APP_TARGET/main.css';

import PlayerActionsWrapper from './library/player/PlayerActionsWrapper';
import LeftBar from './library/left-bar/LeftBar';
import CustomLeftBarContainer from './library/custom/-APP_TARGET/content/CustomLeftBarContainer';
import CustomDragLayerWrapper from './library/dnd/CustomDragLayerWrapper';
import CoverFlowWrapper from './library/coverflow/CoverFlowWrapper';
import TabBar from './library/tab-bar/TabBar';
import MainManager from './library/content/MainManager';
import ModalWrapper from './library/modal/ModalWrapper';
import PopupWrapper from './library/popup/PopupWrapper';
import PreviewWrapper from './library/preview/PreviewWrapper';
import ErrorWrapper from './library/error/ErrorWrapper';
import TooltipWrapper from './library/tooltip/TooltipWrapper';

import { connect, useDispatch } from "react-redux";
import {
  setStateFullScreen,
  setModal
} from "../actions/index";

import ModalCTA from './library/modal/ModalCTA';
import ModalButton from './library/modal/ModalButton';

let timeoutMaintenance = null;
function ConnectedLibrary({
  backend, maxWidth, maxHeight, fullHeight, playerCoordinates, style,
  active, isFullScreen,
  setStateFullScreen,
  bannerBrowser
}) {

  maxHeight = (!bannerBrowser) ? maxHeight : maxHeight - Config.BANNER_BROWSER_HEIGHT;
  const leftBarContainerHeight = (fullHeight) ? maxHeight : maxHeight - playerCoordinates.height;
  const toggleFullScreen = (e, state = null) => { setStateFullScreen((state !== null) ? state : !isFullScreen) }
  const styleTabbar = { top: playerCoordinates.height };
  const msTouchDelay = 0;

  // FOR MAINTENANCE
  const dispatch = useDispatch();
  useEffect(() => {
    if (!active) {
      const onReload = () => { window.location.reload(true); }
      timeoutMaintenance = setTimeout(() => {
        dispatch(setModal({
            content: (
              <ModalCTA
                title={`Sorry, the DJ App is currently in maintenance.`}
                styleContainer={{marginTop: `-60%`, marginLeft: `-15%`}}
                styleModal={{ minWidth: 400 }}
              >
                <ModalButton label={`Try again`} onClick={onReload} />
              </ModalCTA>
            ),
            underlayClickExits: false
          }));
      }, 12000); // 6000
    } else {
      clearTimeout(timeoutMaintenance);
      dispatch(setModal(null));
    }
  }, [active, dispatch])

  return active ? (
    <DndProvider backend={ backend === `touch` ? TouchBackend : HTML5Backend } options={{ enableTouchEvents: true, enableMouseEvents: true, enableHoverOutsideTarget: true, delay: msTouchDelay }}>
      <div id="library" style={style} className={`bp-library flexRow bpc ${fullHeight && `fullHeight`} ${Config.API_NAME} `}>

        <LeftBar height={maxHeight}>
          <CustomLeftBarContainer height={leftBarContainerHeight} fullHeight={fullHeight} />
        </LeftBar>

        <div className={`flexColumn`}>
          <CoverFlowWrapper maxWidth={maxWidth} isFullHeight={fullHeight}
            height={ isFullScreen ? maxHeight : playerCoordinates.height }
            isFullScreen={isFullScreen} onFullScreen={toggleFullScreen} />
          <TabBar style={styleTabbar} />
          <MainManager
            maxWidth={maxWidth} height={maxHeight - playerCoordinates.height - 49}
            playerCoordinates={playerCoordinates} fullHeight={fullHeight}
          />
        </div>

        <CustomDragLayerWrapper layer={`custom_drag_layer`} />
        <ModalWrapper height={playerCoordinates.height + 80} />
        {Config.POPUPS && <PopupWrapper />}
        <PreviewWrapper />
        <ErrorWrapper />
        <TooltipWrapper />
        <PlayerActionsWrapper />
      </div>
    </DndProvider>
  ) : (
    <>
      <ModalWrapper height={playerCoordinates.height + 80} />
    </>
  );

}

ConnectedLibrary.propTypes = {
  backend: PropTypes.string.isRequired,
  maxWidth: PropTypes.number.isRequired,
  maxHeight: PropTypes.number.isRequired,
  fullHeight: PropTypes.bool.isRequired,
  playerCoordinates: PropTypes.object.isRequired,
  style: PropTypes.object.isRequired
}

const Library = connect(
  state => ({
    active: !!state.api,
    isFullScreen: state.isFullScreen,
    bannerBrowser: state.bannerBrowser
  }),
  dispatch => ({
    setStateFullScreen: state => dispatch(setStateFullScreen(state))
  })
)(ConnectedLibrary);

export default Library;
